import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ExportState } from './export.model';
import { ExportStore } from './export.store';

@Injectable({ providedIn: 'root' })
export class ExportStoreQuery extends QueryEntity<ExportState> {
  constructor(protected readonly store: ExportStore) {
    super(store);
  }
}
